import React from "react";
import PhoneCSSFallback from "./PhoneCSSFallback";

/**
 * Detects WebGL availability. If missing (or crashes), renders a high-quality
 * CSS phone mockup so the page never breaks.
 */
function detectWebGL() {
    if (typeof window === "undefined") return false;
    try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("webgl2") || canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        return !!ctx;
    } catch (e) {
        return false;
    }
}

class PhoneErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { hasError: false }; }
    static getDerivedStateFromError() { return { hasError: true }; }
    componentDidCatch(err) { console.error("PhoneR3F crash — falling back to CSS phone:", err); }
    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
}

export default function PhoneR3FSafe({ screenSrc, scrollProgress, forceFallback }) {
    const [ready, setReady] = React.useState(false);
    const [canWebGL, setCanWebGL] = React.useState(false);
    const [PhoneR3F, setPhoneR3F] = React.useState(null);

    React.useEffect(() => {
        const ok = detectWebGL();
        setCanWebGL(ok);
        if (ok && !forceFallback) {
            import("./PhoneR3F")
                .then((m) => { setPhoneR3F(() => m.default); setReady(true); })
                .catch((e) => { console.error("Failed to load PhoneR3F", e); setReady(true); });
        } else {
            setReady(true);
        }
    }, [forceFallback]);

    const fallback = <PhoneCSSFallback screenSrc={screenSrc} />;

    if (!ready) return <div className="w-full h-full" />;
    if (!canWebGL || forceFallback || !PhoneR3F) return fallback;

    return (
        <PhoneErrorBoundary fallback={fallback}>
            <PhoneR3F screenSrc={screenSrc} scrollProgress={scrollProgress} />
        </PhoneErrorBoundary>
    );
}
